import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ShowChartIcon(props: IconProps) {
    return <Icon {...props} iconKey={"show_chart"}/>
}
